export const getPageNums = (cur, total) => {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const s = new Set([1, total]);
    for (let i = Math.max(1, cur - 2); i <= Math.min(total, cur + 2); i++) s.add(i);
    return [...s].sort((a, b) => a - b);
};
